/**
 * Cross-platform SHA-256 hash for manager PINs.
 *
 * Web (and Next.js SSR on Node 19+): uses the Web Crypto API (`crypto.subtle`).
 * React Native: lazy-imports `expo-crypto` so the web bundle doesn't try to
 * include it. The dynamic import is only reached on RN where `crypto.subtle`
 * is undefined.
 */

export async function sha256Hex(input: string): Promise<string> {
  const subtle = (globalThis as { crypto?: { subtle?: SubtleCrypto } }).crypto?.subtle;
  if (subtle) {
    const enc = new TextEncoder();
    const buf = await subtle.digest("SHA-256", enc.encode(input));
    return Array.from(new Uint8Array(buf))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }
  const Crypto = await import("expo-crypto");
  return Crypto.digestStringAsync(Crypto.CryptoDigestAlgorithm.SHA256, input);
}
